<div class="cvdp-dd" *ngIf="!inline" ngbDropdown display="dynamic" placement="bottom-start bottom-end top-start"
  (openChange)="onOpenChange($event)">

  <button type="button" id="cvdpPeriodTrigger" class="cvdp-dd__trigger" ngbDropdownToggle
    [disabled]="disabled || busy"
    [attr.aria-busy]="busy"
    [attr.aria-label]="busy ? 'Loading time periods' : ('Time period: ' + (selectedPeriod ? selectedPeriod.TimePeriodName : 'none selected'))">
    <i class="cvdp-dd__icon" aria-hidden="true"
      [class.far]="!busy" [class.fa-calendar-alt]="!busy"
      [class.fas]="busy" [class.fa-spinner]="busy" [class.fa-spin]="busy"></i>
    <span class="cvdp-dd__value" [class.cvdp-dd__value--muted]="busy || !selectedPeriod">
      {{ busy ? 'Loading...' : (selectedPeriod ? selectedPeriod.TimePeriodName : 'Select a time period...') }}
    </span>
    <i class="fas fa-chevron-down cvdp-dd__caret" aria-hidden="true"></i>
  </button>

  <div ngbDropdownMenu aria-labelledby="cvdpPeriodTrigger" class="cvdp-dd__menu" role="menu">

    <p class="cvdp-dd__hint" *ngIf="helperText">{{ helperText }}</p>

    <div class="cvdp-dd__loading" *ngIf="loading || !periods">
      <i class="fas fa-spinner fa-spin me-2" aria-hidden="true"></i>Loading time periods...
    </div>

    <div class="cvdp-dd__list" *ngIf="periods">
      <button *ngFor="let period of periods; trackBy: trackByPeriodId" type="button" role="menuitem" ngbDropdownItem
        class="cvdp-dd__item"
        [class.cvdp-dd__item--selected]="isSelected(period)"
        [attr.aria-current]="isSelected(period) ? 'true' : null"
        (click)="selectPeriod(period)">
        <span class="cvdp-dd__item-label">{{ period.TimePeriodName }}</span>
        <i class="fas fa-check cvdp-dd__item-check" *ngIf="isSelected(period)" aria-hidden="true"></i>
      </button>
    </div>

  </div>
</div>

<!-- Inline list for the mobile sheet. Deliberately its own markup rather than the
     menu above: the rows are sized for touch and carry no menu semantics. -->
<div class="cvdp-inline" *ngIf="inline">

  <p class="cvdp-inline__hint" *ngIf="helperText">{{ helperText }}</p>

  <div class="cvdp-inline__loading" *ngIf="loading || !periods">
    <i class="fas fa-spinner fa-spin me-2" aria-hidden="true"></i>Loading time periods...
  </div>

  <div class="cvdp-inline__list" *ngIf="periods" role="group" aria-label="Time period">
    <button *ngFor="let period of periods; trackBy: trackByPeriodId" type="button" class="cvdp-inline__item"
      [class.cvdp-inline__item--selected]="isSelected(period)"
      [attr.aria-current]="isSelected(period) ? 'true' : null"
      (click)="selectPeriod(period)">
      <span class="cvdp-inline__item-label">{{ period.TimePeriodName }}</span>
      <i class="fas fa-check cvdp-inline__item-check" *ngIf="isSelected(period)" aria-hidden="true"></i>
    </button>
  </div>

</div>
